import React, { Component } from 'react';
import styled from 'styled-components';
import Button from '../Button/Button';

const SessionExtensionModalContainer = styled.div`
  padding: ${({ theme }) => theme.unit(6)} ${({ theme }) => theme.unit(3)};
  background-color: ${({ theme }) => theme.c.bg.primary};

  & .heading {
    ${({ theme }) => theme.typographyRebrand.heading['2xl']}
    color: ${({ theme }) => theme.c.text.primary};

    margin-bottom: ${({ theme }) => theme.unit(3)};
  }

  & .body {
    ${({ theme }) => theme.typographyRebrand.body.md}
    color: ${({ theme }) => theme.c.text.primary};

    margin-bottom: ${({ theme }) => theme.unit(3)};
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media screen and (min-width: ${({ theme }) => theme.minWidthBreakpoint.tablet}px) {
    flex-direction: row;
    justify-content: center;
  }
`;

class SessionExtensionModal extends Component {

  render() {
    const {
      timer = '0:46',
      onCta,
      sessionExtensionHeadingText = 'Session will timeout... [TIMER]',
      sessionExtensionBodyText = 'Session inactive...',
      sessionExtensionSignInText = 'Keep Session Alive',
      sessionExtensionSignOutText = 'End Session',
    } = this.props;

    const title = `${sessionExtensionHeadingText.replace('[TIMER]', timer)}${timer === 1 ? '' : 's'}`;

    return (
      <div className="session-extension">
        <div role="dialog" className="am-modal am-modal--visible" data-testid="modal-wrapper" aria-modal="true">
          <div className="am-modal__content">
            <SessionExtensionModalContainer>
              <h2 aria-label={title} className="heading">
                {title}
              </h2>
              <p className="body">{sessionExtensionBodyText}</p>
              <ButtonsContainer>
                <Button
                  variant="primary"
                  data-track-click="session-extension-stay-signed-in"
                  data-track-id="on-page-interaction"
                  onClick={() => onCta('signIn')}
                  buttonText={sessionExtensionSignInText}
                />
                <Button
                  variant="secondary"
                  data-track-click="session-extension-sign-out"
                  data-track-id="on-page-interaction"
                  onClick={() => onCta('signOut')}
                  buttonText={sessionExtensionSignOutText}
                />
              </ButtonsContainer>
            </SessionExtensionModalContainer>
          </div>
        </div>
      </div>
    );
  }
}

export default SessionExtensionModal;
